import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import {
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Col,
  Row,
  Collapse,
  Input,
  Button,
} from 'reactstrap';
import { FILTER_FIELDS } from '../config';
import FilterChips from './FilterChips';

const FilterInput = ({ field, value, onChange, refs }) => {
  if (field.type === 'date') {
    return (
      <DatePicker
        dateFormat="dd/MM/yyy"
        className="form-control date-picker-pym"
        selected={value}
        onChange={onChange}
      />
    );
  }
  if (field.type === 'select') {
    return (
      <Input
        type="select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {field.options(refs).map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Input>
    );
  }
  return (
    <Input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

/**
 * Collapsible filter panel driven by `tab.filterFields`. Edits stay in a
 * local draft until Search, which hands the draft up as the applied filter.
 */
const PoFilter = ({ tab, applied, onSearch }) => {
  const [isOpen, setIsOpen] = useState(Boolean(tab.filterOpen));
  const [draft, setDraft] = useState(applied);
  useEffect(() => setDraft(applied), [applied]);

  const branches = useSelector(({ purchaseOrder }) => purchaseOrder.branches);
  const expenseTypes = useSelector(
    ({ purchaseOrder }) => purchaseOrder.tujuanPengeluaran,
  );
  const refs = { branches, expenseTypes };

  const setField = (key) => (value) =>
    setDraft((current) => ({ ...current, [key]: value }));

  return (
    <>
      <div className={isOpen ? 'dropup' : null}>
        <button
          type="button"
          className="btn btn-secondary mt-2 dropdown-toggle btn-collapse-pym"
          onClick={() => setIsOpen(!isOpen)}
        >
          Filter
        </button>
      </div>
      <FilterChips
        tab={tab}
        applied={applied}
        refs={refs}
        onChange={onSearch}
      />
      <Collapse isOpen={isOpen}>
        <Card className="mt-1">
          <CardBody>
            <Form>
              <Row form>
                {tab.filterFields.map((key) => (
                  <Col sm={6} md={6} key={key}>
                    <FormGroup row>
                      <Label sm={4}>{FILTER_FIELDS[key].label}</Label>
                      <Col sm={7}>
                        <FilterInput
                          field={FILTER_FIELDS[key]}
                          value={draft[key]}
                          onChange={setField(key)}
                          refs={refs}
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                ))}
              </Row>
            </Form>
          </CardBody>
          <div className="d-flex flex-row-reverse">
            <Button
              color="success"
              className="mt-0"
              style={{
                position: 'absolute',
                backgroundColor: 'rgb(50, 178, 128)',
                width: '20%',
              }}
              onClick={() => onSearch(draft)}
            >
              Search <FontAwesomeIcon icon={faSearch} className="ml-2" />
            </Button>
          </div>
        </Card>
      </Collapse>
    </>
  );
};

export default PoFilter;
